import { AbstractControl } from '@angular/forms';

export class MatchingValidation {
  static studentAndParentEmailsDifferent(c: AbstractControl): any {
    let sEmail: string = c.get('studentEmail').value
    let pEmail: string = c.get('parentEmail').value

    if (sEmail === pEmail) {
      c.get('parentEmail').setErrors({ cantBeSameAsStudentEmail: true })
    }
    else {
      c.get('parentEmail').setErrors(null)
    }
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/validators/matching.ts